import { Badge, Box, Text } from '@cmpsr/components';

type RiskAnalysisSummaryProps = {
  bgColor: string;
  color: string;
  text: string;
};

export default function RiskAnalysisSummary(props: RiskAnalysisSummaryProps) {
  return (
    <Box mb={7} data-testid="risk-analysis-summary">
      <Badge variant="subtle" textTransform="none" py={1} px={2} mb={4} bgColor={props.bgColor} color={props.color}>
        {props.text}
      </Badge>
      <Text
        variant="text-body-meta-medium"
        color="tan"
        textTransform="uppercase"
        fontSize={{ base: '14px', lg: '16px' }}
      >
        Your Overall Cancer <br />
        Risk By Age
      </Text>
    </Box>
  );
}
